import React, {useEffect} from 'react';
import {
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@material-ui/core';
import useStyles from '../../styles/styles';
import setDate from "../../utils/setDate";
import {useQuery} from "@apollo/react-hooks";
import {gql} from "apollo-boost";
import {Alert} from "@material-ui/lab";

const SignatureBlocksTableShortForm = ({apiRequestId, setHasSignatureBlock}) => {
    const classes = useStyles();

    const {loading, error, data} = useQuery(gql`
        query SignatureBlocks($apiRequestId: UUID!) {
            signatureBlocks(apiRequestId: $apiRequestId) {
                id
                loanRequestId
                blockActionTaken
                blockReason
                signatureBlock {
                    blockReason
                    blockValue
                    expires
                    filterField
                    filterType
                    id
                    signatureBlockSource
                    trafficSourceStateGroupId
                }
            }
        }
    `, {
        variables: {
            apiRequestId: apiRequestId,
        },
        context: {
            clientName: "kgraphql"
        }
    });

    const blockActions = data?.signatureBlocks ?? []

    useEffect(() => {
        if (blockActions.length) {
            console.log('block actions', blockActions)
            setHasSignatureBlock(true)
        }
    }, [blockActions])

    if (loading) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left">Lead Scores</Typography>
                <Paper className={classes.paper}>
                    <CircularProgress color="inherit"/>
                </Paper>
            </>
        );
    }

    if (!blockActions || error) {
        return (
            <>
                <Typography variant="h4" component="h4" align="left">Lead Scores</Typography>
                <Paper className={classes.paper}>
                    <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                </Paper>
            </>
        );
    }

    function Row(blockAction) {

        return (
            <TableRow key={blockAction.id} id={blockAction.id}>
                <TableCell variant="body">{blockAction.signatureBlock.blockReason}</TableCell>
                <TableCell variant="body">{blockAction.signatureBlock.filterField}</TableCell>
                <TableCell variant="body">{blockAction.signatureBlock.blockValue}</TableCell>
                <TableCell variant="body">{blockAction.blockActionTaken}</TableCell>
                <TableCell
                    variant="body">{setDate(blockAction.signatureBlock.dateCreated)}</TableCell>
                <TableCell variant="body">{setDate(blockAction.signatureBlock.expires)}</TableCell>
            </TableRow>
        )
    }

    return (
        <>
            <Typography variant="h4" component="h4" align="left" id={"signature-block-table"}>
                Signature Block
            </Typography>
            <Paper className={classes.paper}>
                <Table className={classes.table} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell variant="head">Reason</TableCell>
                            <TableCell variant="head">Filter Field</TableCell>
                            <TableCell variant="head">Value</TableCell>
                            <TableCell variant="head">Action</TableCell>
                            <TableCell variant="head">Created</TableCell>
                            <TableCell variant="head">Expires</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {blockActions.map(blockAction =>
                            Row(blockAction)
                        )}
                        {!blockActions.length ? (
                            <TableRow>
                                <TableCell variant="body" colSpan={6}>
                                    No Results
                                </TableCell>
                            </TableRow>
                        ) : null}
                    </TableBody>
                </Table>
            </Paper>
        </>
    );
};

export default SignatureBlocksTableShortForm;
